const userUri = "https://vue-testhere.firebaseio.com/user.json";
const citiesUri = "https://vue-testhere.firebaseio.com/data.json";

const updateUserUri = "https://vue-testhere.firebaseio.com/user/";

// URI for weather icons
// EXAMPLE http://openweathermap.org/img/wn/01d@4x.png
const weatherIconsUri = "http://openweathermap.org/img/wn/";
const weatherApiUri = "http://api.openweathermap.org/data/2.5/weather";

export { userUri, citiesUri, weatherApiUri, weatherIconsUri, updateUserUri };
